/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
import { FC } from 'react';
import Select from 'react-select';

export interface SimpleSelectProps {
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  options?: any;
  placeholder?: string | undefined;
  [x: string]: any;
  value?: any;
  defaultValue?: any;
  disabled?: boolean;
  isError?: boolean;
  menuPlacement?: string;
  isSearchable?: boolean
  isDefault?: boolean
  isWhiteBg?: boolean
}

export const SimpleSelect: FC<SimpleSelectProps> = ({
  options,
  onChange,
  onBlur,
  value,
  defaultValue,
  placeholder = 'select',
  restProps,
  disabled = false,
  isError = false,
  menuPlacement='bottom',
  isSearchable,
  isDefault,
  isWhiteBg= true,
}: SimpleSelectProps) => {
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      height: 32,
      fontSize: isDefault? 16 : 14,
      borderRadius: 4,
      paddingLeft: 12,
      border: isError ? '1px solid red' : '1px solid white',
      backgroundColor: isWhiteBg? 'white': '#F9FAFB',
      fontWeight:isDefault ? 600: 400,
      boxShadow: state.isFocused ? '0 0 0 1px #F7941E' : 'none',
      borderColor: state.isFocused ? '#F7941E' : isError ? 'red' : 'white',
      '&:hover': {
        borderColor: 'white',
      },
    }),
    option: (
      styles: any,
      { isDisabled, isFocused, isSelected }: any
    ) => ({
      ...styles,
      color: '#F7941E',
      backgroundColor: isSelected
        ? '#f7951e24'
        : isFocused
        ? '#f7951e33'
        : 'white',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      color: '#F7941E',
      '&:hover': {
        color: '#F7941E',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  return (
    <Select
      menuPlacement={menuPlacement}
      styles={customStyles}
      options={options}
      className="sd-classes-select"
      placeholder={placeholder}
      theme={(theme: any) => ({
        ...theme,
        borderRadius: 10,
        colors: {
          ...theme.colors,
          primary25: '#F7941E', // option Hover colour
          neutral80: isDefault?'#F7941E':'#737791', // typing Inside the select
          neutral20: 'white', // Outline colour
          primary: 'white',
          neutral30: 'white',
        },
      })}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      defaultValue={defaultValue}
      isDisabled={disabled}
      isSearchable={isSearchable}
      {...restProps}
    />
  );
};

export default SimpleSelect;
